/** Extract YYYY-MM-DD date string from a Date object. */
export function toDateStr(d: Date): string {
  return d.toISOString().split("T")[0]!;
}
